(() => {
  if (window.__paleoCartClearInstalled) return;
  window.__paleoCartClearInstalled = true;

  const refreshCartMarkup = async cart => {
    const separator = location.search ? '&' : '?';
    const response = await fetch(`${location.pathname}${location.search}${separator}section_id=helper-cart&_=${Date.now()}`, {
      cache: 'no-store'
    });
    if (!response.ok) throw new Error(await response.text());

    const freshDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
    const cartForm = document.getElementById('AjaxCartForm');
    const freshCartForm = freshDocument.getElementById('AjaxCartForm');
    const subtotal = document.getElementById('AjaxCartSubtotal');
    const freshSubtotal = freshDocument.getElementById('AjaxCartSubtotal');

    if (cartForm && freshCartForm) {
      cartForm.innerHTML = freshCartForm.innerHTML;
      if (typeof cartForm.ajaxifyCartItems === 'function') cartForm.ajaxifyCartItems();
    }
    if (subtotal && freshSubtotal) subtotal.innerHTML = freshSubtotal.innerHTML;

    document.querySelectorAll('[data-header-cart-count]').forEach(element => {
      element.textContent = String(cart.item_count || 0);
    });

    const freshTotal = freshDocument.querySelector('[data-cart-total]');
    if (freshTotal) {
      document.querySelectorAll('[data-header-cart-total]').forEach(element => {
        element.innerHTML = freshTotal.innerHTML;
      });
    }

    document.getElementById('site-cart-sidebar')?.classList.toggle('cart-is-empty', cart.item_count === 0);
    document.dispatchEvent(new CustomEvent('cart-updated', { detail: { cart, source: 'cart-clear' } }));
    document.dispatchEvent(new CustomEvent('ck:cart-changed'));
  };

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-clear]');
    if (!button || button.disabled) return;

    event.preventDefault();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(button.dataset.cartClearUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      if (!response.ok) throw new Error(await response.text());
      await refreshCartMarkup(await response.json());
    } catch (error) {
      console.error('Cart clear failed', error);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
